import React from 'react';

type TitleProps = {
    title: string;
    classes?: string;
};

const Title: React.FC<TitleProps> = ({ title, classes }) => {
    return (
        <h2
            className={`text-xl lg:text-3xl text-primary-dark dark:text-white font-bold flex gap-1 mb-4 lg:mb-8 items-center ${classes}`}
        >
            {title}
        </h2>
    );
};

export default Title;
